package at.apa.statistictracker.di

import at.apa.statistictracker.configuration.Configuration
import at.apa.statistictracker.coroutines.StatisticTrackerCoroutineScope
import at.apa.statistictracker.data.local.StatisticPayloadDao
import at.apa.statistictracker.data.local.UserPropertyDao
import at.apa.statistictracker.data.remote.StatisticTrackerApiService
import at.apa.statistictracker.db.createDatabase
import at.apa.statistictracker.service.StatisticEventService
import org.koin.core.module.Module
import org.koin.dsl.module

private fun getConfigModule(configuration: Configuration) = module {
    single { configuration }
}

private fun createDbModule() = module {
    single {
        createDatabase(get<Configuration>().sqlDriver) }
    single { StatisticPayloadDao(get()) }
    single { UserPropertyDao(get()) }
}

private fun createServiceModule() = module {
    single { StatisticEventService(get(), get(), get(), get()) }
    single { StatisticTrackerApiService(get()) }
}

private fun createCoroutineModule() = module {
    single { StatisticTrackerCoroutineScope() }
}

fun createKoinModules(configuration: Configuration): List<Module> {
    return listOf(
        getConfigModule(configuration),
        createDbModule(),
        createServiceModule(),
        createCoroutineModule()
    )
}
